import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const usersPage = {
    mobile: {
        mainWrapper: {
            display: "flex",
            flexDirection: "column" as "column"
        },
        leftWrapper: {},
        rightWrapper: {
            padding: "6.04vw 2.41vw 0 4.83vw"
        },
        newUser: {
            display: "flex",
            alignItems: "center",
            fontSize: "3.86vw",
            fontWeight: "bold" as "bold",
            color: Color.DeepBlack,
            padding: "0",
            iconWrapper: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "8.21vw",
                width: "8.21vw",
                background: Color.DeepBlack,
                borderRadius: "4.10vw",
                marginLeft: "2.41vw"
            },
            icon: {
                height: "2.90vw",
                width: "2.90vw",
                fill: Color.White
            }
        },
        backButton: {
            container: {
                display: "flex",
                margin: "0 0 5.79vw"
            },
            buttonWrapper: {
                display: "flex",
                alignItems: "center"
            },
            button: {
                paddingTop: "0.7vw",
                width: "6.76vw",
                height: "6.76vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "50%"
            },
            icon: {
                fill: Color.DeepBlack,
                width: "50%"
            },
            text: {
                display: "inline",
                marginLeft: "2.65vw",
                fontSize: "3.86vw",                
                color: Color.LightBlack
            }
        },
        titleWrapper: {
            display: 'flex'
        },
        title: {
            fontSize: "6.04vw",
            fontWeight: "bold" as "bold",
            color: Color.LightBlack
        },
        selectRow: {
            display: "contents"
        },
        perPageSelect: {
            marginLeft: "auto",                
            marginTop: "unset",
            buttonWrapper: { 
                width: "13.58vw"
            },
            button: {
                width: "auto",
                marginLeft: "auto"
            },
            hover: {
                width: "13.58vw"
            }
        },
        addUserWrapper: {
            display: "none"
        },
        userList: {
            marginTop: '3vw'
        },
        userCard: {
            display: "flex",
            flexDirection: "column",
            padding: "4.83vw 2.47vw",
            userProfile: {
                display: "flex",
                flexDirection: "row" as "row"
            },
            userAvatar: {
                height: "17.87vw",
                width: "17.87vw",
                borderRadius: "50%",                        
                marginRight: "4.83vw",
                objectFit: "cover"
            },
            bottomBorder: {
                borderBottom: "2px solid" + Color.MiddleAsh,
            },
            details: {
                display: "flex",
                flexDirection: "column"
            },
            nameWrapper: {},
            name: {
                fontSize: "4.34vw",
                fontWeight: "bold" as "bold"
            },
            role: {
                fontSize: "3.38vw",
                fontWeight: "500",
                marginTop: "1vw",
                red: {
                    color: Color.Red
                }, 
                blue: {
                    color: Color.Blue
                },
                orange: {
                    color: Color.HarvestGold
                }
            },
            contactWrapper: {
                marginTop: "1vw"
            },
            email: {
                fontSize: "3.38vw",
                fontWeight: "500",
                color: Color.DeepAsh
            },
            statusWrapper: {
                marginTop: "1.5vw"
            },
            status: {
                width: "28.98vw",
                height: "7.25vw",
                fontSize: "3.86vw",
                fontWeight: "bold"
            },
            pending: {
                display: "grid",
                alignItems: "center",
                justifyItems: "center",
                background: Color.HarvestGold,
                color: Color.White,
                borderRadius: "6.03vw"
            },
            admin: {
                display: "grid",
                alignItems: "center",
                justifyItems: "center",
                background: Color.Blue,
                color: Color.White,
                borderRadius: "6.03vw"
            },
            removeButton: {
                background: Color.Linen,
                color: Color.Red,
                borderRadius: "1.69vw"
            }
        },
        pagination: {
            nextButton: {
                width: "7.25vw",
                height: "7.25vw",
                backgroundColor: Color.DeepBlack,
                border: "none"
            },
            button: {
                color: Color.LightBlack,
                active: {
                    backgroundColor: Color.SharpAsh
                }
            }
        },
        noUsers: {
            wrapper: {
                borderRadius: "2.77vw",
                border: "1px solid " + Color.HarvestGold,
                backgroundColor: Color.LightGold,
                display: "flex",
                alignItems: "center" as "center",
                justifyContent: "center" as "center",
                padding: "2.41vh",
                color: Color.HarvestGold,
                fontSize: "4.5vw",
                fontFamily: Font.Poppins,
                margin: "21.73vw auto 0 auto",
                textAlign: "center"
            },
            icon: {
                marginRight: "1.43vw",
                width: "8.33vw",
                height: "8.33vw",
                marginLeft: "1vw"
            }
        },
        userDialog: {
            container: {
                width: "calc(100% - 9.66vw)",
                height: "unset",
                padding: "7.246vw 4.93vw",
                borderRadius: "2.415vw 2.415vw 0 0"
            },
            closeButton: {
                overflow: "visible"
            }
        },
        dialog: {
            title: {
                marginTop: "unset",
                marginBottom: "7vw",
                fontSize: "7.24vw",
                color: Color.LightBlack
            },
            inputText: {
                marginTop: "4.10vw",
                fontSize: "4.34vw",
                fontWeight: "400",
                fontFamily: Font.Poppins,
                color: Color.SharpAsh
            },
            input: {
                margin: "0",
                paddingLeft: "4.83vw",
                fontSize: "4.34vw",
                width: "auto",
                height: "12.07vw",
                color: Color.SharpAsh,
                backgroundColor: Color.LightAsh,
                borderRadius: "2.41vw",
                border: "none"
            },       
            message: {
                margin: "4.83vw 0 0 0",
                fontSize: "3.86vw",
                color: Color.MiddleBlack,
                font: Font.Default,
                fontWeight: "600"
            },
            secondaryMessage: {
                margin: "1.2vw 0 0 0",
                fontSize: "3.86vw",
                color: Color.MiddleBlack,
                font: Font.Default,
                fontWeight: "600"
            },
            buttons: {
                justifyContent: "center"
            },
            button: {
                width: "50%",
                height: "12.07vw",
                fontWeight: "bold",
                fontSize: "4.83vw",
                borderRadius: "2.41vw",
                margin: "7.24vw 0 0 0",
                blue: {
                    backgroundColor: Color.Blue,
                    color: Color.White,
                    marginLeft: "2.89vw"
                },
                ash: {
                    border: "3px solid " + Color.SharpAsh,
                    color: Color.SharpAsh,
                    background: "transparent"
                },
                borderBlue: {
                    border: "3px solid " + Color.Blue,
                    color: Color.Blue,
                    background: "transparent",
                    marginLeft: "2.89vw"
                },
                red: {
                    border: "none",
                    color: Color.Red,
                    backgroundColor: Color.LightRed
                }
            }
        }
    },
    desktop: {
        mainWrapper: {            
            flexDirection: "row" as "row",
            padding: "1.56vw"
        },        
        leftWrapper: {},
        rightWrapper: {
            padding: "0 0 0 2.32vw",
            width: "100%"
        },
        backButton: {   
            container: {
                margin: "0"
            },         
            button: {
                paddingTop: "0.3vw",
                backgroundColor: Color.Ash, 
                width: "2.60vw",
                height: "2.60vw"
            },
            text: {
                marginLeft: "1.3vw",
                fontSize: " 0.93vw",
                fontWeight: 'bold'
            }
        },
        titleWrapper: {
            marginTop: "1vw",
            alignItems: 'center'
        },
        title: {
            fontSize: "2.60vw",
            color: Color.DeepBlack
        },
        perPageSelect: {
            marginBottom: "unset",
            marginLeft: "unset",
            buttonWrapper: { 
                width: "4.06vw"
            },
            button: {
                height: "1.82vw",
                marginLeft: "1.04vw"
            },
            hover: {
                width: "4.06vw"
            }
        },
        addUserWrapper: {
            display: "block",
            marginLeft: "auto",
            addUser: {
                display: "flex",
                background: Color.DeepBlack,
                boxShadow: "5px 5px 50px #00000027",
                color: Color.White,
                fontWeight: "bold" as "bold",
                marginLeft: "auto",
                width: "13.59vw",
                height: "2.60vw",
                borderRadius: "0.52vw",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "0.94vw"
            },
            icon: {
                height: "0.88vw",
                width: "0.88vw",
                fill: Color.White,
                marginLeft: "0.68vw"
            }
        },
        userList: {
            marginTop: '0.78vw'
        },
        userCard: {
            padding: "1.04vw",
            hovered: {
                background: Color.White,
                borderTop: "1px solid " + Color.MiddleAsh,
                borderLeft: "1px solid " + Color.MiddleAsh,
                borderBottom: "1px solid " + Color.MiddleAsh,
                borderRight: "1px solid " + Color.MiddleAsh,
                borderRadius: "0.52vw",
                boxShadow: "10px 10px 50px #00000014"
            },
            userAvatar: {
                height: "3.85vw",
                width: "3.85vw",          
                marginRight: "1.04vw"
            },
            bottomBorder: {
                borderBottom: "1px solid" + Color.MiddleAsh
            },
            nameWrapper: {
                width: "24vw"
            },
            details: {
                flexDirection: "row",
                marginTop: "0.70vw"
            },
            name: {
                fontSize: "1.04vw"
            },
            role: {
                fontSize: " 0.93vw",
                marginTop: "0.28vw"
            },
            contactWrapper: {
                width: "30vw",
                margin: "0 0 0 3.27vw"
            },
            contact: {
                fontSize: "1.04vw",
                color: Color.DeepAsh
            },
            email: {
                fontSize: "0.93vw",
                fontWeight: 'bold'
            },
            statusWrapper: {
                display: "flex",
                margin: "0"
            },
            status: {
                width: "6.25vw",
                height: "1.82vw",  
                fontSize: "0.83vw",
                fontWeight: "bold",
                alignSelf: "center",
                marginRight: "unset",
                marginLeft: "0.31vw",
                marginTop: "0.16vw"
            },
            admin: {
                borderRadius: "1.3vw"
            },
            pending: {
                borderRadius: "1.3vw"
            },
            removeButton: {              
                borderRadius: "0.36vw"
            }
        },
        paginationWrapper: {
            display: "flex",
            alignItems: "center",
            marginTop: "2.10vw"
        },
        pagination: {
            margin: "unset",
            marginLeft: "auto",
            nextButton: {
                width: "2.60vw",
                height: "2.60vw"
            }
        },
        noUsers: {
            wrapper: {
                width: "75%",
                borderRadius: "0.52vw",
                margin: "10vh auto 0 auto",
                padding: "1.56vw 0 1.56vw 0",
                fontSize: "1.137vw"
            },
            icon: {
                marginRight: "1.02vw",
                width: "1.58vw",
                height: "1.58vw"
            }
        },
        userDialog: {
            container: {
                width: "21.33vw",                
                padding: "3.489vw 3.54vw",
                borderRadius: "0.52vw"
            }
        },
        removalDialog: {
            container: {
                width: "39.33vw",
                height: "27vh"
            }
        },
        dialog: {
            title: {
                fontSize: "1.56vw",
                color: Color.LightBlack,
                marginBottom: "1.51vw"
            },
            inputText: {
                marginTop: "0.88vw",
                fontSize: "0.93vw",
                width: "12.05vw"
            },
            input: {
                paddingLeft: "1.04vw",
                fontSize: "0.93vw",
                borderRadius: "0.52vw",
                height: "2.60vw"
            },
            message: {
                margin: "1.51vw 0 0 0",
                fontSize: "1.2vw",
                color: Color.MiddleBlack,
                textAlign: "center",
                lineHeight: "1.5"
            },
            secondaryMessage: {
                margin: "0",
                fontSize: "1.2vw",
                color: Color.MiddleBlack,
                textAlign: "center",
                lineHeight: "1.5"
            },
            button: {
                width: "10.15vw",
                height: "2.604vw",
                fontSize: "1.041vw",
                borderRadius: "0.52vw",
                margin: "1.25vw 0 0 0",
                blue: {
                    marginLeft: "0.625vw"
                },
                borderBlue: {
                    marginLeft: "0.625vw"
                }
            }
        }
    }
}